/** Where the nav column ends, in window pixels, for the title bar's View
 *  picker to line up with (2026-10-03). NavPane (components/Panes.tsx)
 *  publishes its resting edge: a pane that is unpinned counts as its strip
 *  even while hover opens it, so the picker does not jump. null on a page
 *  without a nav pane. */
import { useEffect, useState } from "react";

let navEdge: number | null = null;
const listeners = new Set<(edge: number | null) => void>();

export function publishNavEdge(edge: number | null): void {
  if (edge === navEdge) return;
  navEdge = edge;
  for (const l of listeners) l(edge);
}

export function useNavEdge(): number | null {
  const [edge, setEdge] = useState(navEdge);
  useEffect(() => {
    listeners.add(setEdge);
    setEdge(navEdge);
    return () => {
      listeners.delete(setEdge);
    };
  }, []);
  return edge;
}
